export default __webpack_public_path__ + "static/media/evreux11.7c467ca4.jpg";